import * as React from "react";
// import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
// import { Formik, Form } from "formik";
// import * as Yup from "yup";
import { useEffect } from "react";
import swal from "sweetalert";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import dayjs, { Dayjs } from "dayjs";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";

import { makeGetRequest, makePostRequest } from "../../../utils/utils";

// const Validation_Schema = Yup.object().shape({
//   selectedGuard: Yup.string().required("Required"),

//   selectedSpot: Yup.string().required("Required"),
// });

function AddDutyModal(props) {

  const navigate = useNavigate();

  const [q] = React.useState("");

  const [guardsList, setGuardsList] = React.useState([]);
  const [selectedGuard, setSelectedGuard] = React.useState("");
  const [spotList, setSpotList] = React.useState([]);
  const [selectedSpot, setSelectedSpot] = React.useState("");
  const [startDate, setStartDate] = React.useState(moment(new Date()));
  const [endDate, setEndDate] = React.useState(moment().add(8, "hours"));
  const [isEditRoaster, setisEditRoaster] = React.useState(false);
  // const [value, setValue] = React.useState(0);
  const [guardErrMsg, setGuardErrMsg] = React.useState("");
  const [spotErrMsg, setSpotErrMsg] = React.useState("");
  const [startDtErrMsg, setStartDtErrMsg] = React.useState("");
  const [endDtErrMsg, setEndDtErrMsg] = React.useState("");

  useEffect(() => {
    GuardsListing();
    SpotListing();

    if (localStorage.getItem("isEditRoaster") === "true") {
      setisEditRoaster(localStorage.getItem("isEditRoaster"));
      let bodyFormData = "";

      makeGetRequest(
        "roaster/getbyid/" + localStorage.getItem("roaster_id"),
        bodyFormData
      )
        .then((response) => {
          if (response.status === 201) {
            var roasterObj = response.data.data;
            setSelectedGuard(roasterObj.guard_id);
            setSelectedSpot(roasterObj.spot_id);
            setStartDate(roasterObj.start_date);
            setEndDate(roasterObj.end_date);
          } else {
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
      // localStorage.removeItem("isEditRoaster");
    }
  }, [q]);

  async function GuardsListing() {
    let bodyFormData = {};

    makePostRequest(
      "guards/guardlisting?searchq=&pageNo=1&count=100&status=true",
      bodyFormData
    )
      .then((response) => {
        if (response.status === 201) {
          console.log("Guards Response ", response);
          //setlength(response.data.data.rowCount);
          const data = response.data.data.rows;
          setGuardsList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function SpotListing() {
    let bodyFormData = "";

    makeGetRequest("spot/getalllist", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          setSpotList(response.data.data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handlechangeGuard = (e) => {
    setSelectedGuard(e.target.value);
  };

  const handlechangeSpot = (e) => {
    setSelectedSpot(e.target.value);
  };

  const handleChangeStartDt = (date) => {
    if (date.format("DD MM YYYY") >= moment().format("DD MM YYYY")) {
      setStartDate(date);
      if (date.format("HH") >= moment().format("HH")) {
        setStartDate(date);
        setEndDate(date.add(8, "hours"));
        if (date.format("mm") >= moment().format("mm")) {
          setStartDate(date);
          setEndDate(date.add(8, "hours"));
        } else {
          swal(
            "Invalid Time!",
            "Unable to select previous time to assign a duty",
            "warning"
          );
          setStartDate(new Date());
          setEndDate(moment().add(8, "hours"));
        }
      } else {
        swal(
          "Invalid Time!",
          "Unable to select previous time to assign a duty",
          "warning"
        );
        setStartDate(new Date());
        setEndDate(moment().add(8, "hours"));
      }
    } else {
      swal(
        "Invalid Date!",
        "Unable to select previous date to assign a duty",
        "warning"
      );
      setStartDate(new Date());
      setEndDate(moment().add(8, "hours"));
    }
  };

  const handleChangeEndDt = (date) => {
    console.log("date.format ", date.format("DD MM YYYY"));
    console.log("startDate.format ", startDate.format("DD MM YYYY"));

    if (date.format("DD MM YYYY") >= startDate.format("DD MM YYYY")) {
      setEndDate(date);
      return;
    } else {
      swal(
        "Invalid Date!",
        "Unable to select previous date to assign a duty",
        "warning"
      );
      if (date.format("HH") > startDate.format("HH")) {
        setEndDate(date);
      } else {
        swal(
          "Invalid Time!",
          "End time should be more than start time of duty",
          "warning"
        );
        setEndDate(new Date());
      }

      if (date.format("mm") > startDate.format("mm")) {
        setEndDate(date);
      } else {
        swal(
          "Invalid Time!",
          "End time should be more than start time of duty",
          "warning"
        );
        setEndDate(new Date());
      }
    }
  };

  async function addRoaster() {
    setGuardErrMsg("");
    setSpotErrMsg("");
    setStartDtErrMsg("");
    setEndDtErrMsg("");
    
    var isEditRoaster = localStorage.getItem("isEditRoaster");

    if (selectedGuard && selectedSpot) {
      await isDutyAssigned(selectedGuard, startDate, endDate);

      if (dutyAssigned) {
        swal("Unable to Assign Duty!", "Duty Already Assigned", "warning");
      } else {
        if (isEditRoaster) {
          let inputdata = {
            roaster_id: localStorage.getItem("roaster_id"),
            guard_id: selectedGuard,
            spot_id: selectedSpot,
            start_date: startDate,
            end_date: endDate,
          };
          makePostRequest("roaster/update", inputdata)
            .then((response) => {
              // checked codition if responce is empty
              if (response.data.data !== undefined) {
                // localStorage.setItem("roaster", response.data.data.spot_id);
                swal(
                  "Success",
                  "Daily Roaster updated successfully",
                  "success",
                  {
                    timer: 1000,
                    buttons: false,
                  }
                );
                localStorage.removeItem("isEditRoaster");
                localStorage.removeItem("roaster_id");

                window.location.reload();
              } else {
              }
            })
            .catch((err) => {
              swal("There was an error!", "more error details", "warning");
            });
        } else {
          let inputdata = {
            guard_id: selectedGuard,
            spot_id: selectedSpot,
            start_date: startDate,
            end_date: endDate,
          };
          makePostRequest("roaster/insert", inputdata)
            .then((response) => {
              // checked codition if responce is empty
              if (response.data.data !== undefined) {
                // localStorage.setItem("spotid", response.data.data.spot_id);
                swal("Success", "Daily Roaster added successfully", "success", {
                  timer: 1000,
                  buttons: false,
                });

                setSelectedGuard("");
                setSelectedSpot("");
                setStartDate("");
                setEndDate("");
              }
            })
            .catch((err) => {
              swal("There was an error!", "more error details", "warning");
            });
        }
      }
    } else {
      if(!selectedGuard)
          setGuardErrMsg("Required");
      if(!selectedSpot)
          setSelectedSpot("Required");
    }
  }

  const [dutyAssigned, setIsDutyAssigned] = React.useState(false);
  async function isDutyAssigned(guardId, startDate, endDate) {
    let bodyFormData = {
      guardId: guardId,
      startDate: moment.utc(startDate),
      endDate: moment.utc(endDate),
    };

    makePostRequest("guards/isdutyassigned", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Assigned Duty Data ", response);
          if (response.data.data.rowCount > 0) setIsDutyAssigned(true);
          else setIsDutyAssigned(false);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }
  return (
    <>
      <div id="successfullAdd">
        <Grid container spacing={3} className="addCommitee1">
          <Grid item xs={12} md={6}>
            <label className="tabsLabel">Select Guard</label>
            <select
              className="inputSt"
              value={selectedGuard}
              onChange={handlechangeGuard}
            >
              <option value="" disabled>
                Select Guard
              </option>
              {guardsList.map((option) => (
                <option
                  key={option.guard_id}
                  value={option.guard_id}
                  data-isd={option.guard_name}
                >
                  {option.guard_name}
                </option>
              ))}
            </select>
            <div className="errorField">{guardErrMsg}</div>
          </Grid>
          <Grid item xs={12} md={6}>
            <label className="tabsLabel">Select Spot</label>
            <select
              className="inputSt"
              value={selectedSpot}
              onChange={handlechangeSpot}
            >
              <option value="" disabled>
                Select Spot
              </option>
              {spotList.map((option) => (
                <option
                  key={option.spot_id}
                  value={option.spot_id}
                  data-isd={option.spot_name}
                >
                  {option.spot_name}
                </option>
              ))}
            </select>
            <div className="errorField">{spotErrMsg}</div>
          </Grid>
          <Grid item xs={12} md={6}>
            <label className="tabsLabel">Select Start Date</label>
            <div className="dateTimeMain">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack className="inputSt">
                  <DateTimePicker
                    value={startDate}
                    onChange={(e) => handleChangeStartDt(e)}
                    renderInput={(params) => <TextField {...params} />}
                    disabledDate={(current) => {
                      return moment().add(-1, "days") >= current;
                    }}
                  />
                </Stack>
              </LocalizationProvider>
            </div>
            <div className="errorField">{startDtErrMsg}</div>
          </Grid>
          <Grid item xs={12} md={6}>
            <label className="tabsLabel">Select End Date</label>
            <div className="dateTimeMain">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack className="inputSt">
                  <DateTimePicker
                    value={endDate}
                    onChange={(e) => handleChangeEndDt(e)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Stack>
              </LocalizationProvider>
            </div>
            <div className="errorField">{endDtErrMsg}</div>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="modalMainBtMain cancelBtForAllOuter">
              <Button className="modalMainBt cancelBtForAll" onClick={()=>navigate("/GuardAssignment")}>Cancel</Button>
              <Button className="modalMainBt" onClick={() => addRoaster()}>
                {isEditRoaster ? <div>Edit</div> : <div>Add</div>}
              </Button>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
              <h4>Success !</h4>
              <p>
                Added Duty <br />
                successfully in database
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
export default AddDutyModal;
